import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { capturarOrigen } from "./helpers/origen-registro";
import { instalarMedicionCarga } from "./helpers/carga-app";
import { Box } from "@mui/material";
import { UserProvider } from "./components/context/UserContext";
import { detectarCaminoAlBackend } from "./helpers/get-client";
import { DxDataProvider } from "./components/context/DxDataContext";
import { InputParamsProvider } from "./components/context/InputParamsContext";
import { AppThemeProvider } from "./components/context/ThemeModeContext";
import { CulturesAlertProvider } from "./components/context/CulturesAlertContext";
import { AcidBaseProvider } from "./components/context/AcidBaseContext";
import { PdfPreviewProvider } from "./components/context/PdfPreviewContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
// Lo que un evento puede llevarse a Sentry y lo que no (RUT y nombre del
// paciente salían en la URL hasta el 14-sep-2026, P0-5 de la auditoría
// 21.719). Las reglas y sus tests viven en helpers/sentry-scrub.js.
import { opcionesDeSentry } from "./helpers/sentry-config";

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || "";
if (SENTRY_DSN) {
  Sentry.init(
    opcionesDeSentry({
      dsn: SENTRY_DSN,
      environment: process.env.REACT_APP_ENV || "production",
      release: process.env.REACT_APP_RELEASE || undefined,
    }),
  );
}

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

// Antes del primer render: se sondea si esta red alcanza el backend directo.
// No bloquea nada (la promesa nunca rechaza y tiene techo propio); los
// requests la esperan solo si sigue en vuelo. Un médico detrás del filtro de su
// institución arranca la sesión ya sabiendo que tiene que salir por la ruta
// alternativa, en vez de descubrirlo pagando un fallo con la clave escrita.
detectarCaminoAlBackend();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <UserProvider>
        <InputParamsProvider>
          <DxDataProvider>
            <AppThemeProvider>
              <CulturesAlertProvider>
              <AcidBaseProvider>
              <PdfPreviewProvider>
              <Box
                sx={{
                  backgroundColor: "background.default",
                  margin: 0,
                  padding: "1rem 1rem 1rem 1rem",
                  height: "100%",
                  minHeight: "96.5vh",
                  fontFamily: "Open Sans, sans-serif",
                }}
              >
                <App />
              </Box>
              </PdfPreviewProvider>
              </AcidBaseProvider>
              </CulturesAlertProvider>
            </AppThemeProvider>
          </DxDataProvider>
        </InputParamsProvider>
      </UserProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// #1731: de qué anuncio llegó esta visita (primer toque); se manda al haber sesión (App.js).
capturarOrigen();
// #1717 R13: tiempos reales de carga por usuario (incluido el lead que todavía no ingresa).
instalarMedicionCarga();
